var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var _a;
import { Component, Prop, Vue } from 'vue-property-decorator';
import { Group } from '@/models/Group';
import { RolesEnum } from '@/items/Roles';
import ErrorHandler from '@/support/ErrorHandler';
import { ucstring } from '@/support/String';
import { quillEditor } from 'vue-quill-editor';
import 'quill/dist/quill.core.css';
import 'quill/dist/quill.snow.css';
import 'quill/dist/quill.bubble.css';
import { GroupIncludes } from '@/models/Model';
import { GroupTypeEnum } from '@/models/GroupType';
import LoaderCard from '@/components/loader-card/LoaderCard';
let GroupNotesDialog = class GroupNotesDialog extends Vue {
    constructor() {
        super(...arguments);
        this.groupResponse = null;
        this.content = '';
        this.disableEditor = false;
        this.isLoading = true;
        this.editorOptions = {
            modules: {
                toolbar: this.$store.state.Auth.hasRole([RolesEnum.TEACHER, RolesEnum.ADMIN, RolesEnum.ROOT, RolesEnum.RESELLER]) ? true : false,
                magicUrl: true,
            },
        };
    }
    async mounted() {
        if (this.groupId) {
            this.groupResponse = await new Group().include([GroupIncludes.TYPE, GroupIncludes.NOTES]).find(this.groupId);
        }
        if (this.selectedGroup)
            this.content = this.selectedGroup.notes || '';
        this.$store.state.Auth.hasRole([RolesEnum.TEACHER, RolesEnum.ADMIN, RolesEnum.ROOT, RolesEnum.RESELLER]) ? this.disableEditor = false : this.disableEditor = true;
        this.isLoading = false;
    }
    onCloseButtonClick() {
        this.$emit('input', false);
    }
    save() {
        if (!this.selectedGroup) {
            return;
        }
        this.selectedGroup
            .include(['audit', 'chat', 'users', 'subjects', 'roles', 'parent'])
            .update({ notes: this.content })
            .then(() => {
            if (this.group)
                this.group.notes = this.content;
            this.$emit('update', this.selectedGroup);
            this.$store.dispatch('openDialog', this.dialogOptions);
        })
            .catch((error) => {
            ErrorHandler.network(error);
        });
    }
    get dialogOptions() {
        return {
            title: this.$t('dialogOptions.confirmation').toString(),
            text: ucstring(this.$t('dialogOptions.save', { item: this.$t('dialogOptions.item.note') }).toString()),
            type: 'success',
            buttons: {
                confirm: {
                    text: this.$t('dialogOptions.button.ok').toString(),
                },
            },
        };
    }
    get isAuthorized() {
        return this.$store.state.Auth.hasRole([RolesEnum.ADMIN, RolesEnum.ROOT, RolesEnum.RESELLER, RolesEnum.TEACHER]);
    }
    get selectedGroup() {
        return this.groupId ? this.groupResponse : this.group;
    }
    get isParnassysGroup() {
        console.log('this.selectedGroup', this.selectedGroup);
        return !!(this.selectedGroup && this.selectedGroup.type && typeof this.selectedGroup.type !== 'string' && this.selectedGroup.type.label === GroupTypeEnum.PARNASSYS);
    }
};
__decorate([
    Prop(),
    __metadata("design:type", typeof (_a = typeof Group !== "undefined" && Group) === "function" ? _a : Object)
], GroupNotesDialog.prototype, "group", void 0);
__decorate([
    Prop(),
    __metadata("design:type", String)
], GroupNotesDialog.prototype, "groupId", void 0);
GroupNotesDialog = __decorate([
    Component({
        components: {
            quillEditor,
            LoaderCard,
        },
    })
], GroupNotesDialog);
export default GroupNotesDialog;
